import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Grid,
} from "@material-ui/core";

import { DocumentPdf } from "./DocumentPdf";

export function PdfContentPopup({
    open,
    setOpen,
    title,
    href,
}: {
    open: boolean,
    setOpen: (open: boolean) => void;
    title: string;
    href: string;
}) {
    const handleClose = () => {
        setOpen(false);
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            maxWidth="md"
            disableScrollLock={true}
        >
            <DialogTitle>{title}</DialogTitle>
            <DialogContent>
                <Grid container justify="center">
                    <DocumentPdf href={href} />
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
};
